import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PROJECT_MANAGEMENT_FEATURE_KEY,
  ProjectManagementState,
  ProjectManagementPartialState,
  projectManagementAdapter,
} from './project-management.reducer';
import { ProjectDto } from '@cradua/data';

// Lookup the 'ProjectManagement' feature state managed by NgRx
export const getProjectManagementState = createFeatureSelector<
  ProjectManagementPartialState,
  ProjectManagementState
>(PROJECT_MANAGEMENT_FEATURE_KEY);

const { selectAll, selectEntities } = projectManagementAdapter.getSelectors();

export const getProjectManagementLoaded = createSelector(
  getProjectManagementState,
  (state: ProjectManagementState) => state.loaded
);

export const getProjectManagementError = createSelector(
  getProjectManagementState,
  (state: ProjectManagementState) => state.error
);

export const loadingProjectManagement = createSelector(
  getProjectManagementState,
  (state: ProjectManagementState) => state.loaded
);

export const getAllProjectManagement = createSelector(
  getProjectManagementState,
  (state: ProjectManagementState) => selectAll(state)
);

export const getProjectManagementEntities = createSelector(
  getProjectManagementState,
  (state: ProjectManagementState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getProjectManagementState,
  (state: ProjectManagementState) => state.selectedProjectManagementId
);

export const getSelected = createSelector(
  getProjectManagementEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getSearchStudentRecord = createSelector(
  getAllProjectManagement,
  getSelectedId,
  (users: ProjectDto[], selectedId) =>
    !selectedId
      ? null
      : users.filter(
          (user) =>
            user.ProjectTitle.toLowerCase().includes(
              String(selectedId).toLowerCase()
            ) ||
            user.Objective.toLowerCase().includes(
              String(selectedId).toLowerCase()
            )
        )
);
